import { isValidUrl as checkUrl } from 'utils/isValidUrl/isValidUrl';

export const isValidUrl = (label: string) => (value?: string) => {
  if (value && !checkUrl(value)) {
    return label;
  }

  return undefined;
};
